import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { CloudUpload, AutoAwesome, Explore } from '@mui/icons-material';
import SEOHead from '../components/SEO/SEOHead';

const AboutPage: React.FC = () => (
  <Box sx={{ maxWidth: 800, mx: 'auto' }}>
    <SEOHead
      title="About Hooliah"
      description="Learn about Hooliah — the AI-powered fashion community where you upload, rate, and discover outfits."
      canonicalUrl="https://hooliah.com/about"
    />

    <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>About Hooliah</Typography>

    <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>Our Mission</Typography>
    <Typography variant="body1" paragraph>
      Hooliah is a community-driven fashion platform that empowers people to share their personal style, discover new outfit ideas, and get honest feedback from fellow fashion enthusiasts. We believe everyone deserves to feel confident in what they wear, and that the best style inspiration comes from real people — not just runways.
    </Typography>

    <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>How It Works</Typography>
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {[
        { icon: <CloudUpload sx={{ fontSize: 40 }} />, title: 'Upload Your Outfit', desc: 'Snap a photo of your outfit and share it with the community. Add details like occasion, brands, and tags.' },
        { icon: <AutoAwesome sx={{ fontSize: 40 }} />, title: 'AI-Powered Analysis', desc: 'Our AI analyzes your outfit, identifying clothing items, colors, and styles to help others discover your look.' },
        { icon: <Explore sx={{ fontSize: 40 }} />, title: 'Discover & Rate', desc: 'Browse trending outfits, rate looks you love, and build your personal style feed based on your preferences.' },
      ].map((step) => (
        <Grid item xs={12} md={4} key={step.title}>
          <Paper sx={{ p: 3, textAlign: 'center', height: '100%' }}>
            <Box sx={{ color: 'primary.main', mb: 1 }}>{step.icon}</Box>
            <Typography variant="h6" gutterBottom>{step.title}</Typography>
            <Typography variant="body2" color="text.secondary">{step.desc}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>

    <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>What Makes Hooliah Different</Typography>
    <Typography variant="body1" paragraph>
      Unlike traditional fashion platforms, Hooliah combines AI-powered outfit analysis with genuine community ratings. Every outfit uploaded is analyzed by our AI to identify clothing items, colors, and style patterns — making it easier for others to find and be inspired by your look. Our community-driven rating system ensures that the most stylish outfits rise to the top, giving you authentic feedback from real people who share your passion for fashion.
    </Typography>
    <Typography variant="body1" paragraph>
      Hooliah is operated by Ameel Kamboh and is built with love for the fashion community. Whether you're a seasoned style influencer or just starting to explore your personal style, Hooliah is your space to express, discover, and connect.
    </Typography>
  </Box>
);

export default AboutPage;
